import {FormModel} from 'src_common/common/mobx-utils/Form';
import { ResultError } from 'src_common/common/mobx-utils/Form/type';

export class InputStatus {
    private inputModel: FormModel<string |  string[] | number | boolean | null>;

    constructor(inputModel: FormModel<string |  string[] | number | boolean | null>) {
        this.inputModel = inputModel;
    }

    get type(): 'success' | 'error' {
        const isError = this.inputModel.result instanceof ResultError;
        const isVisited = this.inputModel.isVisited;
        if (isVisited && isError) {
            return 'error';
        }
        return 'success';
    }

    get message(): string | null {
        return this.inputModel.errorMessage;
    }

}
